<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              id="farm_seeding_catching"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.crop') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-crop"
              size="large"
              v-model="model.crop_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in crops"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3">
            <label>{{ $t('common_words.date') }}:</label>
            <br />
            <el-date-picker
              class="shadow-sm date-form"
              v-model="model.date_save"
              type="date"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.generate') }}
            </l-button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert.message }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        v-if="showSowingCatch && !messageAlert"
      >
        <div class="mt-4 px-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table class="table table-striped table-bordered not-last-td">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '100px' }"
                    >
                      <strong>{{ $t('common_words.allotment') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.allotment_area_ha') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.variety') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.pruning_reasons') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.sowing_method') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('sowing.seed_type') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('fertilization.fertilization') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('irrigation.irrigation') }}
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.observation') }}
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nReseeding" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="model.lot_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, i) in availableLots"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="`${i}-${option.id}`"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-input
                        type="text"
                        style="min-width: 140px"
                        class="shadow-sm text-center"
                        :value="allotmentAreaById(model.lot_id[index - 1])"
                        disabled
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.crop_variety_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, v) in cropVariety"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="v + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.pruning_reason_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in pruningReasons"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="j + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.sowing_method_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in sowingMethods"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="j + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.seed_type_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in seedTypes"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="j + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        collapse-tags
                        clearable
                        multiple
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        style="min-width: 230px"
                        v-model="model.fertilizer_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in fertilizers"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="j + option.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select shadow-sm"
                        size="large"
                        v-model="model.irrigation_system_id[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, j) in irrigations"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="`${j}-${option.id}`"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-input
                        clearable
                        type="text"
                        class="shadow-sm"
                        v-model="model.observation[index - 1]"
                      >
                      </el-input>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="display: table-cell"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="'Agregar'"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nReseeding++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nReseeding > 1 && isDelete()"
                          v-tooltip.top-center="'Borrar'"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateDetail()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <br />
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { resetObjectProperties } from 'src/util/Util.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        date_save: null,
        farm_id: null,
        crop_id: null,
        lot_id: [],
        pruning_reason_id: [],
        sowing_method_id: [],
        seed_type_id: [],
        crop_variety_id: [],
        fertilizer_ids: [],
        irrigation_system_id: [],
        ground_preparation: [],
        observation: [],
        nReseeding: 1,
        detailsId: [],
      },
      showSowingCatch: false,
      messageAlert: null,
      farms: [],
      crops: [],
      lots: [],
      pruningReasons: [],
      sowingMethods: [],
      seedTypes: [],
      cropVariety: [],
      fertilizers: [],
      irrigations: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptionsDetails: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },

  mixins: [MixinNotification, MixinMasters, MixinPermissions],

  computed: {
    availableLots() {
      return this.lots.filter((lot) => !this.model.lot_id.includes(lot.id));
    },
  },
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    allotmentAreaById(lotId) {
      const lot = this.lots.find((lot) => Number(lot.id) === Number(lotId));

      return lot ? lot.area : null;
    },
    handleDelete(index) {
      this.model.lot_id.splice(index, 1);
      this.model.pruning_reason_id.splice(index, 1);
      this.model.sowing_method_id.splice(index, 1);
      this.model.seed_type_id.splice(index, 1);
      this.model.crop_variety_id.splice(index, 1);
      this.model.fertilizer_ids.splice(index, 1);
      this.model.irrigation_system_id.splice(index, 1);
      this.model.ground_preparation.splice(index, 1);
      this.model.observation.splice(index, 1);
      this.model.nReseeding--;
    },

    cleanForm() {
      if (this.messageAlert && !this.messageAlert.show)
        this.messageAlert = null;
      this.model.nReseeding = 1;
      this.model = {
        ...resetObjectProperties(this.model, [
          'farm_id',
          'crop_id',
          'date_save',
          'nReseeding',
        ]),
      };
    },

    confirmDelete() {
      if (this.model.id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.sowing.selected_sowing_capture')
        ).then((result) => {
          if (result.value) this.deleteSowingCatch();
        });
      } else this.cleanForm();
    },

    deleteSowingCatch() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'seeding/reseedingcatchs';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showSowingCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.reseeding.reseeding_capture_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    validate() {
      if (this.model.farm_id == null)
        return this.validationInputsRequired('farm');
      else if (this.model.crop_id == null)
        return this.validationInputsRequired('crop');
      else {
        this.cleanForm();
        this.loadData();
      }
    },

    validateDetail() {
      if (this.model.lot_id == null)
        return this.validationInputsRequired('lots');
      this.storeUpdateSowingCatchs();
    },

    storeUpdateSowingCatchs() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'seeding/reseedingcatchs';

        if (this.model.id) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showSowingCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    loadData() {
      this.showHideLoading(true);
      let data = {
        farm_id: this.model.farm_id,
        crop_id: this.model.crop_id,
        date_save: this.model.date_save,
        route: 'seeding/reseeding/catchs',
      };
      this.showSowingCatch = false;

      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.model.farm_id),
        Axios.postMasters(data),
        Axios.getMasters('pruning/reasons/field'),
        Axios.getMasters('seeding/sowingmethods/field'),
        Axios.getMasters('seeding/seedtypes/field'),
        Axios.getMasters('cropvarieties'),
        Axios.getMasters('fertilization/fertilizers/field'),
        Axios.getMasters(`irrigation/systems/field/${this.model.farm_id}`),
      ]).then((response) => {
        const [
          responseLots,
          responseReseedingCatch,
          responsePruningreason,
          responseSowingmethod,
          responseSeedtype,
          responseCropVariety,
          responseFertilizer,
          responseIrrigation,
        ] = response;
        this.lots = responseLots.data.data;
        const reseedingCatch = responseReseedingCatch.data.data;
        this.pruningReasons = responsePruningreason.data.data;
        this.sowingMethods = responseSowingmethod.data.data;
        this.seedTypes = responseSeedtype.data.data;
        this.cropVariety = responseCropVariety.data.data;
        this.fertilizers = responseFertilizer.data.data;
        this.irrigations = responseIrrigation.data.data;

        if (reseedingCatch['closing']) {
          this.messageAlert = {
            show: true,
            message: reseedingCatch['closing'].message,
          };
          delete reseedingCatch['closing'];
        } else this.messageAlert = null;

        if (reseedingCatch.length > 0) {
          this.model.id = reseedingCatch[0].id;
          this.model.nReseeding =
            reseedingCatch[0].reseeding_catch_details.length;
          const lotSelecteds = [];

          reseedingCatch[0].reseeding_catch_details.forEach((detail) => {
            const {
              lot_id,
              pruning_reason_id,
              sowing_method_id,
              seed_type_id,
              crop_variety_id,
              fertilizers,
              irrigation_system_id,
              ground_preparation,
              observation,
            } = detail;

            lotSelecteds.push(lot_id);
            this.model.detailsId.push(lot_id);
            this.model.pruning_reason_id.push(pruning_reason_id);
            this.model.sowing_method_id.push(sowing_method_id);
            this.model.seed_type_id.push(seed_type_id);
            this.model.crop_variety_id.push(crop_variety_id);
            this.model.fertilizer_ids.push(
              fertilizers.map((fertilizer) => fertilizer.id)
            );
            this.model.irrigation_system_id.push(irrigation_system_id);
            this.model.ground_preparation.push(ground_preparation);
            this.model.observation.push(observation);
          });

          try {
            this.model.lot_id = [];
            setTimeout(() => {
              this.model.lot_id = [...lotSelecteds];
            }, 5);

            this.showSowingCatch = true;
          } catch (error) {}
        } else {
          this.showSowingCatch = true;
          this.cleanForm();
        }

        this.showHideLoading();
      });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('farms/crops'),
      ])
        .then((response) => {
          const [responseFarm, responseCrop] = response;
          this.farms = responseFarm.data.data;
          this.crops = responseCrop.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
